<template>
  <el-dialog
    :title="model.id ? '编辑设备应用' : '新增设备应用'"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="应用名称" prop="name">
        <el-input
          style="width: 100%"
          v-model="model.name"
          placeholder="请输入应用名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="包含工艺" prop="crafts">
        <div class="tag-container">
          <el-tag
            :key="tag"
            v-for="tag in model.crafts"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createDeviceCraft, updateDeviceCraft } from '@/service/getData'
export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请填写应用名称', trigger: 'change' },
        ],
      },
      inputVisible: false,
      inputValue: '',
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateDeviceCraft(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createDeviceCraft(this.model)
            if (res.code == 0) {
              this.visible = false
              this.$emit('created', res.data)
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleClose(tag) {
      this.model.crafts.splice(this.model.crafts.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue.trim()
      if (inputValue && this.model.crafts.indexOf(inputValue) == -1) {
        this.model.crafts.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
  },
}
</script>

<style scoped>
/deep/.center-input .el-input__inner {
  text-align: center;
}
.tag-container {
  width: 100%;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.button-new-tag {
  width: 50px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  vertical-align: bottom;
}
</style>